<template>
  <div style="padding:1rem;">
    <el-card>
      <el-form
        ref="form_ref"
        :model="form"
        :rules="rules"
        label-width="60px"
        label-position="right"
      >
        <el-form-item label="姓名" prop="name" style="width:60%;">
          <el-input v-model="form.name" placeholder="请输入姓名"> </el-input>
        </el-form-item>
        <el-form-item label="手机" prop="iphone">
          <el-input
            type="number"
            v-model="form.iphone"
            placeholder="请输入手机号"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <el-button
        @click="submit"
        icon="el-icon-check"
        type="primary"
        size="mini"
      >
        提交
      </el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        // 姓名
        name: [
          {
            required: true,
            message: "请输入您的姓名",
            trigger: "blur",
          },
        ],
        // 手机号
        iphone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
      },
      form: {
        iphone: "",
      },
    };
  },

  methods: {
    submit() {
      this.$refs.form_ref.validate((valid) => {
        if (valid) {
          this.$message.success("提交成功，请您耐心等待回复！");
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
    padding-bottom: 1.4rem;
}


.el-button {
    float:right;
    margin-top:10rem;
}
</style>
